import { jwtDecode } from "jwt-decode";

//create function to check for token expiration
export const logoutWhenTokenExp = () => {

    const refreshToken = localStorage.getItem("refreshToken");
    const decoded = jwtDecode(refreshToken);
    const exp = decoded.exp;
    const iat = decoded.iat;
    
    const timeDiff = exp - iat;
    console.log("Time difference: ", timeDiff);

    setTimeout(() => {
        // console.log('This code will run after 1 second when refresh token expires');
        const refreshToken1 = localStorage.getItem("refreshToken");
        const decoded1 = jwtDecode(refreshToken1);
        const exp1 = decoded1.exp;

        // get current time
        const now = Date.now();
        const currentTime = Math.round(now / 1000);
        console.log("Current time: ", currentTime);

        //if current time is greater than expiration time, log user out
        if (currentTime > exp1) {
          console.log("Token expired!");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/"
        }
        

        

      }, timeDiff * 1000 + 1000); 
};

const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    
    if (decoded.exp < currentTime) {
      return true;
    }
    
    return false;
  } catch (error) {
    return true;
  }
};

const getTokenExpirationDate = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp;
  } catch (error) {
    return null;
  }
};

